// extracted by mini-css-extract-plugin
export default {"loader":"SiteLoader_loader__MDNlF"};